import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import ComplementCategory from "../entities/stores/categoryComplement.entity";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";
import CategoryComplementDB from "./categoryComplement";


class ComplementCategoryStoreDB extends FirestorePipe {

  public static readonly colName = 'CategoriesComplement'

  constructor(idEstab: string, idStore: string) {
    if (!idEstab || !idStore)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${CategoryComplementDB.colName}`);
  }
  public define(id: string, data: ComplementCategory): Promise<any> {
    return this._define(id, data);
  }


  public async create(data: ComplementCategory): Promise<any> {
    await this.saveFile(data);
    try {
      return await this._create(data);
    } catch (error: any) {
      if(data.image_ref) {
        await this.deleteFile(data.image_ref)
      }
      if(data.banner_ref) {
        await this.deleteFile(data.banner_ref)
      }
      throw error.message
    }
  }
  public async update(id: string, data: ComplementCategory): Promise<any> {
    await this.saveFile(data);
    return await this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<ComplementCategory[]> {
    return this._getAll<ComplementCategory>(...params);
  }
  public get(id: string): Promise<ComplementCategory> {
    return this._get(id);
  }
  public on(listener: (data: ComplementCategory[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }


  private async saveFile(data: ComplementCategory) {
    if(data.image) {
      const resultUpload = await this.uploadFile(new Date().getTime().toString(), data.image);
      data.image_ref = resultUpload.ref.fullPath;
      data.image_url = resultUpload.url;
    }

    if(data.banner) {
      const resultUpload = await this.uploadFile(new Date().getTime().toString(), data.banner);
      data.banner_ref = resultUpload.ref.fullPath;
      data.banner_url = resultUpload.url;
    }
    delete data.image
    delete data.banner
  }

}

export default ComplementCategoryStoreDB;